/**
 * Calendar months, as ranges.
 *
 * A rolling thirty days and the month of August are different questions and
 * different numbers: the first ends now, the second ended on the first of
 * September. The switcher offers both because a reader asking "how is the last
 * month going" and one asking "what did August do" are not the same reader.
 *
 * Bounds are UTC and closed at the start, open at the end: a month runs from
 * its first instant to the first instant of the next. The server normalises
 * whatever arrives, and these arrive already normalised.
 */

const NAMES = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
] as const;

export type Month = {
  readonly label: string;
  readonly since: string;
  readonly until: string;
};

function moment(year: number, month: number): string {
  const at = new Date(Date.UTC(year, month, 1, 0, 0, 0));
  return at.toISOString().replace(/\.\d{3}Z$/, "Z");
}

/**
 * The month containing `now` and the ones before it, newest first.
 *
 * The current month is included and is deliberately incomplete: a month that
 * has not finished is still a real question, and the panel already says the
 * account may not have lived through the whole of a period.
 */
export function recentMonths(now: Date, count = 6): readonly Month[] {
  const months: Month[] = [];
  for (let back = 0; back < count; back += 1) {
    const year = now.getUTCFullYear();
    const index = now.getUTCMonth() - back;
    const at = new Date(Date.UTC(year, index, 1));
    months.push({
      label: `${NAMES[at.getUTCMonth()] ?? ""} ${String(at.getUTCFullYear())}`,
      since: moment(at.getUTCFullYear(), at.getUTCMonth()),
      until: moment(at.getUTCFullYear(), at.getUTCMonth() + 1),
    });
  }
  return months;
}
